<!-- 分页组件 -->
<template>
  <div class="pageBox" :class="[position]">
    <el-pagination  @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :current-page.sync="currentPage"
                    :page-sizes=pageSizeArr
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                   >
    </el-pagination>

  </div>
</template>

<script>
  export default {
    props:{
      position:{
        type:String,
        default:"right"
      }
    },
    name: 'page',
    data () {
      return {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizeArr:[10, 30, 50, 100, 200]
      };
    },
    methods: {
      handleSizeChange: function handleSizeChange(val) {
        this.pageSize = val;
        this.$emit('handle-page');
      },
      handleCurrentChange: function handleCurrentChange(val) {
        this.currentPage = val;
        this.$emit('handle-page');
      },
      changePageSize(n){
        this.pageSize = n;
        this.pageSizeArr = [n,n*3,n*5,n*10,n*20];
      }
    },
    mounted(){
      this.$store.commit("addPageVueObject",this);
    }
  }
</script>

<style lang="less" scoped>
 .pageBox{
   display: flex;

   padding-top: 30px;
   margin-right: 60px;
   &.center{
     justify-content: center;
   }
   &.right{
     justify-content: flex-end;
   }
 }

</style>
